import { InjectionToken } from '@angular/core';

import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as login from '../reducers/login.reducer';

import { IAppState } from '../interfaces/app-state.interface';

import * as personnelState from './personnel-state.reducer';

const reducers: ActionReducerMap<IAppState> = {
  login: login.reducer,
  personnelState: personnelState.reducer,
};

export const reducerToken = new InjectionToken<ActionReducerMap<IAppState>>('Reducers');

export function getReducers() {
  return reducers;
}

export const reducerProvider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export const metaReducers: MetaReducer<IAppState>[] = [];
